type ID = string | number

export const ROUTE_PATH = {
  HOME: '/',

  LOGIN: '/login',
  LOGIN_CALLBACK: '/login/callback',
  LOGIN_CALLBACK_LINE: '/login/callback/line',
  RESET_PASSWORD: '/reset-password',
  /* should be email/confirmed, need to notify to app dev, if this changed */
  EMAIL_CONFIRMED: '/email_confirmed',
  BOOKMARKS: '/bookmarks',
  SUBSCRIPTION_CANCEL: '/subscription/cancel',

  CONFERENCE: (conferenceId: ID = ':conferenceId') =>
    `/conference/${conferenceId}`,

  TIMELINE_FOLLOWING: '/',
  TIMELINE_PUBLIC: '/timeline',
  TIMELINE_HASHTAG: (hashtag: string = ':hashtag') =>
    `/timeline/hashtag/${hashtag}`,

  TIMELINE_TESTING_TOOLS: '/timeline-testing-tools',

  POST: (postId: ID = ':postId') => `/post/${postId}`,
  POST_REPOST: (postId: ID = ':postId') => `/post/${postId}/reposts`,
  POST_GIFTS: (postId: ID = ':postId') => `/post/${postId}/gifts`,

  CONVERSATION: (conversationId: ID = ':conversationId') =>
    `/conversation/${conversationId}`,

  CHAT: '/chat',

  GROUP: (groupId: ID = ':groupId') => `/group/${groupId}`,
  GROUP_DETAIL: (groupId: ID = ':groupId') => `/group/${groupId}/detail`,
  GROUP_INVITE: (groupId: ID = ':groupId') => `/group/${groupId}/invite`,
  GROUP_ALBUM: (groupId: ID = ':groupId') => `/group/${groupId}/album`,
  GROUP_SEARCH_POST: (groupId: ID = ':groupId') =>
    `/group/${groupId}/search/post`,
  GROUP_SEARCH_THREAD_POST: (groupId: ID = ':groupId') =>
    `/group/${groupId}/search/thread-post`,

  GROUP_HIGHLIGHTS: (groupId: ID = ':groupId') =>
    `/group/${groupId}/highlights`,

  GROUP_INFORMATION: (groupId: ID = ':groupId') =>
    `/group/${groupId}/information`,
  GROUP_WALKTHROUGH: (groupId: ID = ':groupId') =>
    `/group/${groupId}/information/walkthrough`,

  GROUP_GIFTS: (groupId: ID = ':groupId') => `/group/${groupId}/gifts`,

  GROUP_POST: (groupId: ID = ':groupId', postId: ID = ':postId') =>
    `/group/${groupId}/post/${postId}`,
  GROUP_POST_REPOST: (groupId: ID = ':groupId', postId: ID = ':postId') =>
    `/group/${groupId}/post/${postId}/reposts`,
  GROUP_POST_GIFTS: (groupId: ID = ':groupId', postId: ID = ':postId') =>
    `/group/${groupId}/post/${postId}/gifts`,
  GROUP_CONVERSATION: (
    groupId: ID = ':groupId',
    conversationId: ID = ':conversationId'
  ) => `/group/${groupId}/conversation/${conversationId}`,

  GROUP_THREADS: (groupId: ID = ':groupId') => `/group/${groupId}/threads`,
  GROUP_THREAD: (groupId: ID = ':groupId', threadId: ID = ':threadId') =>
    `/group/${groupId}/threads/${threadId}`,
  GROUP_THREAD_INFORMATION: (
    groupId: ID = ':groupId',
    threadId: ID = ':threadId'
  ) => `/group/${groupId}/threads/${threadId}/info`,
  GROUP_THREAD_POST: (
    groupId: ID = ':groupId',
    threadId: ID = ':threadId',
    postId: ID = ':postId'
  ) => `/group/${groupId}/threads/${threadId}/post/${postId}`,
  GROUP_THREAD_CONVERSATION: (
    groupId: ID = ':groupId',
    threadId: ID = ':threadId',
    conversationId: ID = ':conversationId'
  ) => `/group/${groupId}/threads/${threadId}/conversation/${conversationId}`,

  GROUPS: '/groups',
  GROUPS_ALL: '/groups/all',
  GROUPS_RANKING: '/groups/ranking',
  GROUPS_CATEGORY: (categoryId: ID = ':categoryId') =>
    `/groups/category/${categoryId}`,

  SEARCH_POSTS: `/search/posts`,
  SEARCH_USERS: `/search/users`,
  SEARCH_HASHTAGS: `/search/hashtags`,
  SEARCH_GROUPS: `/search/groups`,

  SETTING: '/user/setting',
  SETTING_PRIVACY: '/user/setting/privacy',
  SETTING_EMAIL: '/user/setting/email',
  SETTING_PASSWORD: '/user/setting/password',
  SETTING_PHONE: '/user/setting/phone',
  SETTING_ACCOUNT_LINKS: '/user/setting/links',
  SETTING_INVITATION: '/user/setting/invitation',
  SETTING_2FA: '/user/setting/2fa',

  SETTING_DATA_MANAGEMENT: '/user/setting/data-management',

  SETTING_CHAT_MANAGEMENT: '/user/setting/chat-management',
  SETTING_CHAT_MANAGEMENT_HIDDEN: '/user/setting/chat-management/hidden',

  SETTING_USER_MANAGEMENT: '/user/setting/user-management',
  SETTING_USER_MANAGEMENT_FOLLOWER_REQUEST:
    '/user/setting/user-management/follower-request',
  SETTING_USER_MANAGEMENT_BLOCK: '/user/setting/user-management/block',
  SETTING_USER_MANAGEMENT_FOLLOWERS: '/user/setting/user-management/followers',
  SETTING_USER_MANAGEMENT_FOLLOWING: '/user/setting/user-management/following',

  SETTING_REVIEW_MANAGEMENT: '/user/setting/review',
  SETTING_REVIEW_MANAGEMENT_SELF: '/user/setting/review/others',

  SETTING_INTERESTS_SELECTION: '/user/setting/faves',

  SETTING_SUBSCRIPTION: '/user/setting/subscription',
  SETTING_SUBSCRIPTION_CHANGE: '/user/setting/subscription/change',
  SETTING_CREDIT_CARD_NEW: '/user/setting/credit-card/new',

  USERS_RANKING: (mode: 'new' | 'popular' | 'all-time' | ':mode' = ':mode') =>
    `/users/ranking/${mode}`,

  USER: (userId: ID = ':userId') => `/user/${userId}`,
  USER_INVITE: (userId: ID = ':userId') => `/user/${userId}/invite`,
  USER_ALBUM: (userId: ID = ':userId') => `/user/${userId}/album`,
  USER_REVIEWS: (userId: ID = ':userId') => `/user/${userId}/reviews`,
  USER_FOLLOWERS: (userId: ID = ':userId') => `/user/${userId}/followers`,
  USER_FOLLOWINGS: (userId: ID = ':userId') => `/user/${userId}/followings`,
  USER_GROUPS: (userId: ID = ':userId') => `/user/${userId}/groups`,
  USER_GIFTS: (userId: ID = ':userId') => `/user/${userId}/gifts`,
  USER_GIFTS_EXCHANGE: (userId: ID = ':userId') =>
    `/user/${userId}/gifts/exchange`,

  ACTIVITIES: '/activities',
  ACTIVITIES_REACTION: '/activities/reaction',

  PHONE_VERIFICATION: '/phone-verification',
  PHONE_VERIFICATION_CONFIRM: '/phone-verification/confirm',

  VIP_PURCHASE: '/vip-purchase',
  VIP_PURCHASE_PLAN_PAYMENT: (planId: ID = ':planId') =>
    `/vip-purchase/${planId}/payment`,

  TESTNET_AIRDROP: '/testnet-airdrop',

  EMPL_DETAILS: '/user/empl-details',
  EMPL_DETAILS_HISTORY: '/user/empl-details/history',
  EMPL_DETAILS_EXPIRY: (emplType: ID = ':emplType') =>
    `/user/empl-details/expiry/${emplType}`,

  AUTHORIZE_WALLET: '/authorize/wallet',
}
